// .pen: aWXWT/Hu86Z (Selfie · Ritual · Momento · primeira|recorrente) + R04r7z (ds/selfie/moment-stats)
import { ArrowsClockwise, Camera, ShieldCheck } from '@phosphor-icons/react';

import pt from '../../../locales/pt';

function format(template, params) {
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    params[key] === undefined ? `{${key}}` : String(params[key]),
  );
}

// .pen: "Selfie · Ritual · Momento · primeira|recorrente" (hero + copy + moment-stats + nota)
export function SelfieMomentStep({
  monthLabel,
  isFirstSelfie = false,
  assetCount = 0,
  debtCount = 0,
}) {
  const copy = pt.snapshots.ritual.moment;
  const title = isFirstSelfie
    ? copy.firstTitle
    : format(copy.title, { month: monthLabel });
  const subtitle = isFirstSelfie ? copy.firstHelp : copy.help;
  const kicker = isFirstSelfie ? copy.firstEyebrow : copy.eyebrow;
  const NoteIcon = isFirstSelfie ? ShieldCheck : ArrowsClockwise;
  const noteTitle = isFirstSelfie ? copy.noteTitleFirst : copy.noteTitle;
  const noteBody = isFirstSelfie
    ? copy.noteBodyFirst
    : format(copy.noteBody, { month: monthLabel });

  return (
    <div className="flex flex-col gap-space-6">
      <div
        data-ds-id="hero"
        className="flex h-[172px] flex-col items-center justify-center gap-space-3 overflow-hidden rounded-ds-xl border border-sage-border bg-gradient-to-b from-sage-tint to-card"
      >
        <div className="flex size-[72px] items-center justify-center rounded-ds-full bg-sage-600 shadow-[0_8px_24px_-4px] shadow-sage-glow">
          <Camera className="size-[34px] text-white" aria-hidden />
        </div>
        <p className="type-section text-sage-on-tint">{kicker}</p>
      </div>

      <div className="flex flex-col gap-space-3">
        <h1 className="font-display text-type-title-page font-semibold leading-[1.25] tracking-tight text-foreground text-balance">
          {title}
        </h1>
        <p className="text-type-body leading-[1.55] text-muted-foreground">{subtitle}</p>
      </div>

      <div
        data-ds-id="ds/selfie/moment-stats"
        className="flex items-center justify-center gap-space-5"
      >
        <div className="flex flex-col items-center gap-0.5">
          <p className="font-display text-type-display-stat font-bold text-foreground">
            {assetCount}
          </p>
          <p className="type-chip text-muted-foreground">{copy.statAssets}</p>
        </div>
        <span className="h-8 w-px bg-border" aria-hidden />
        <div className="flex flex-col items-center gap-0.5">
          <p className="font-display text-type-display-stat font-bold text-foreground">
            {debtCount}
          </p>
          <p className="type-chip text-muted-foreground">{copy.statDebts}</p>
        </div>
        <span className="h-8 w-px bg-border" aria-hidden />
        <div className="flex flex-col items-center gap-0.5">
          <p className="font-display text-type-display-stat font-bold text-foreground">~2 min</p>
          <p className="type-chip text-muted-foreground">{copy.statTime}</p>
        </div>
      </div>

      <div className="flex items-start gap-space-3 rounded-ds-lg border border-border bg-card p-space-4">
        <NoteIcon className="size-5 shrink-0 text-sage-600" aria-hidden />
        <div className="flex flex-col gap-space-1">
          <p className="type-label-lg font-semibold text-card-foreground">{noteTitle}</p>
          <p className="text-type-body-sm leading-[1.5] text-muted-foreground">{noteBody}</p>
        </div>
      </div>
    </div>
  );
}

export default SelfieMomentStep;
